import { render, staticRenderFns } from "./Reporte-acuses.vue?vue&type=template&id=226fc9ce&scoped=true&"
import script from "./Reporte-acuses.vue?vue&type=script&lang=js&"
export * from "./Reporte-acuses.vue?vue&type=script&lang=js&"
import style0 from "./Reporte-acuses.vue?vue&type=style&index=0&id=226fc9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fc9ce",
  null
  
)

export default component.exports